module.exports = __webpack_public_path__ + "assets/move_to-mobile.f232b497.svg";